import React from 'react';
import { TextInput, Button } from '../../components';
import * as PATHS from '../../settings/paths';
import AuthWrapper from './AuthWrapper/AuthWrapper';
import { Row, Col } from 'react-flexbox-grid';
import styles from './styles.module.css'
import { Link } from 'react-router-dom';
const Login = () => {
  return (
    <AuthWrapper>
      <div className={styles.login}>
        <h3>Sign In</h3>
        <p>Enter Your Username & Password</p>
        <TextInput placeholder={'Email Address'} />
        <TextInput placeholder={'Password'} />
        <Row>
          <Col lg={5} xs={12}>
            <Link to={PATHS.FORGOT_PASSWORD} className={styles.forgot}>
              {'Forgot Password'}
            </Link>
          </Col>
          <Col lg={3} xs={12}></Col>
          <Col lg={4} xs={12}>
            <Button style={{ backgroundColor: "var(--text-red)" }}>{'Sign In'}</Button>
          </Col>
          <Row>
            <Col lg={12} xs={12}>
              <div className={styles.dontHaveAccount}>Don’t have an account yet?
                <Link to={PATHS.REGISTER} className={styles.signUp}>
                  {'Sign Up !'}
                </Link>
              </div>
            </Col>
          </Row>
        </Row>
      </div>

    </AuthWrapper>
  );
};

export default Login;
